import { Helmet } from 'react-helmet';

import { SETTINGS } from '@/entities/settings';
import { API_ROUTES } from '@/shared/api/constants';
import { useUserSummary } from '@/shared/lib/hooks/service';

import cls from './styles.module.pcss';

export function CommonMenu() {
  const { account } = useUserSummary();

  return (
    <>
      <div id="common_menu" className={cls.CommonMenu} />

      <Helmet>
        <script
          async
          id="common_menu_loader"
          type="text/javascript"
          data-ot-ignore=""
          src={`//${SETTINGS.cm.feHost}/loader.min.js`}
          data-frontend_url={`//${SETTINGS.cm.feHost}`}
          data-service="ptl"
          data-project="mk"
          data-realm={!!SETTINGS.isStaging ? 'lite' : 'runet'}
          data-language="ru"
          data-backend_url={`//${SETTINGS.cm.beHost}`}
          data-token_url="/api/v1/auth/menu-token/"
          data-login_url={API_ROUTES.LOGIN}
          data-logout_url="/api/v1/auth/logout/"
          data-registration_url={`https://${SETTINGS.cm.regHost}/registration/?game=mk`}
          data-incomplete_profile_url={`https://${SETTINGS.cm.regHost}/personal/`}
          data-notifications_enabled="False"
          data-content_layout_max_width="1500"
          data-user_id={account?.spa_id}
          data-user_name={account?.username}
        />
      </Helmet>
    </>
  );
}
